export default __webpack_public_path__ + "static/media/chainLink.f42003e0.svg";